import { useFilterEmployeeFavoriteContext } from "./filter-employee-favorite.context";

export function FilterEmployeeFavorite() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterEmployeeFavoriteContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}